import { NbMenuItem } from '@nebular/theme';

export const MENU_ATTENDANCE: NbMenuItem =
{
  title: 'Atención',
  icon: 'layers-outline',
  children: [
    {
      title: 'Solicitudes',
      link: '/views/requests/agent-request-list',
    }
  ],
};
